import React from 'react';
import "./HomeServices.scss";
import { Link } from 'react-router-dom';
import { useLanguage } from "../../LanguageContext";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from 'react-responsive';
import HomeServicesOrbital from './HomeServicesOrbital.jsx';
import HomeServicesConcentric from './HomeServicesConcentric.jsx';
import HomeServicesOrbital2 from './HomeServicesOrbital2.jsx';

import triangleImage from '../../assets/images/HomeServices/triangle.svg';
import squareImage from '../../assets/images/HomeServices/square.svg';

const HomeServices = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const isMobile = useMediaQuery({ maxWidth: 767 });
  
  return (
    <div className="home-services">
      <div className="home-services-heading">
        <h2>{t("home_services_title")}</h2>
        <p className="primary">{t("home_services_description")}</p>
      </div>

        <div className="services-container">
            <div className="service-card">
                {isMobile ? (
                  <img src={triangleImage} alt="Service 1" className="service-image" />
                ) : (
                  <HomeServicesOrbital />
                )}
                <div className="card-content">
                    <h3>{t("home_services_title_1")}</h3>
                    <button className="service-btn">
                        <Link to="/services">
                            {t("home_services_button_1")}
                            <span className="btn-arrow">→</span>
                        </Link>
                    </button>
                </div>
            </div>
            <div className="service-card">
                {isMobile ? (
                  <img src={squareImage} alt="Service 2" className="service-image" />
                ) : (
                  <HomeServicesConcentric />
                )}
                <div className="card-content">
                    <h3>{t("home_services_title_2")}</h3>
                    <button className="service-btn">
                        <Link to="/services">
                            {t("home_services_button_2")}
                            <span className="btn-arrow">→</span>
                        </Link>
                    </button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default HomeServices